<div class="flex flex-col gap-6 py-2">
  <p class="text-gray-700" i18n>
    How would you like to record your voice? Choose your preferred method:
  </p>

  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <button
      type="button"
      (click)="selectPushToTalk()"
      class="flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-primary-200 bg-primary-50/50 hover:bg-primary-100/50 hover:border-primary-400 transition-colors cursor-pointer text-left"
    >
      <i class="fas fa-hand-paper text-4xl text-primary-600"></i>
      <div class="flex flex-col gap-1">
        <span class="font-semibold text-gray-900 text-center" i18n>
          Hold to record
        </span>
        <span class="text-sm text-gray-600 text-center" i18n>
          Press and hold the button while speaking. Release when done.
        </span>
      </div>
    </button>

    <button
      type="button"
      (click)="selectClickToRecord()"
      class="flex flex-col items-center gap-3 p-6 rounded-xl border-2 border-primary-200 bg-primary-50/50 hover:bg-primary-100/50 hover:border-primary-400 transition-colors cursor-pointer text-left"
    >
      <i class="fas fa-microphone text-4xl text-primary-600"></i>
      <div class="flex flex-col gap-1">
        <span class="font-semibold text-gray-900 text-center" i18n>
          Click to record
        </span>
        <span class="text-sm text-gray-600 text-center" i18n>
          Click to start, click again to stop. Stops automatically after a few
          seconds.
        </span>
      </div>
    </button>
  </div>
</div>
